export default "__VITE_ASSET__CgabXmmT__"